<div id="confirmation-modal-template" class="modal-content">
    <div class="modal-header">
        <h1 class="modal-title">{{ title | translate }}</h1>
    </div>

    <div class="modal-body">
        <p [innerHTML]="description | translate"></p>
        <div class="btn-group">
            <button type="submit" class="btn btn--plain btn--primary" (click)="cancel()">
                {{ cancelLabel | translate }}
            </button>
            <button type="button" class="btn btn--ghost btn--default" data-dismiss="modal" (click)="confirm()">
                {{ confirmLabel | translate }}
            </button>
        </div>
    </div>
</div>
